import { ApiResponse } from '@/types';
import { apiClient } from './api';

export interface CommentStone {
  id: string | number;
  name: string;
  price: number | string;
}

export const commentStonesApi = {
  async getCommentStones(): Promise<ApiResponse<CommentStone[]>> {
    return apiClient.get<CommentStone[]>('/comment-stones/');
  },

  async purchaseCommentStone(
    stoneId: string | number
  ): Promise<ApiResponse<Record<string, unknown>>> {
    return apiClient.post<Record<string, unknown>>(
      `/comment-stones/${stoneId}/purchase/`,
      {}
    );
  },
};
